<template>
  <div v-show='cpntMostrar' class="cpnt-app-geral cpnt-app-input cpnt-app-campo" :class='cpntInputMontarClass'>
    <!-- SETA O CAMPO STATUS -->
    <RF-Status v-if='cpntInputStatusCampo !== ""' :cpntStatus='cpntInputStatusCampo' :cpntTamanho='5'></RF-Status>

    <!-- MOSTRA A TELA -->
    <template v-else-if="value !== '__INICIAL__'">
      <!-- SETA O INPUT -->
      <!-- <input v-if="cpntInputMontarMascara === '' || ([ 'numero_decimal', 'valor' ].indexOf(cpntMask) !== -1 && cpntDisabled === true && cpntValue === '')" -->
      <input v-if="cpntInputMontarMascara === ''"
      autocomplete="off"
      :id="cpntId"
      :type="cpntType"
      :tabIndex='cpntTabIndex'
      :disabled="cpntDisabled"
      :maxlength="cpntInputMontarMaxLength"
      :value="value"
      @keyup.enter='cpntInputOnKeyPressEnter'
      @keydown='cpntInputOnKeyDown'
      @blur='cpntInputOnBlur'
      @paste="cpntInputOnPaste"
      ref="input"
      @keyup="cpntInputOnChange" />

      <!-- <currency-input v-else-if="[ 'numero_decimal', 'valor' ].indexOf(cpntMask) !== -1"
      :tabIndex='cpntTabIndex'
      :currency="null"
      :disabled="cpntDisabled"
      :precision="precisao"
      :autoDecimalMode="autoDecimalMode"
      :auto-decimal-mode="autoDecimalMode"
      :value="value"
      @keyup="cpntInputOnChange"
      @keyup.enter='cpntInputOnKeyPressEnter'
      @blur='cpntInputOnBlur'
      ref="input"
      ></currency-input> -->

      <!-- SETA O CAMPO COM A MASCARA -->
      <the-mask v-else
      :masked='true' 
      :tabIndex='cpntTabIndex'
      :mask="cpntInputMontarMascara"
      :id='cpntId'
      :value="value"
      :disabled="cpntDisabled"
      :maxlength="cpntInputMontarMaxLength"
      @input="cpntInputOnChange"
      ref="input"
      ></the-mask>

      <template v-if="cpntMask === 'valorDecimalNovo'">
        <div class="cpnt-input-botao-decimal" :title="usarDecimal === true ? 'Desmarque está opção para utilizar apenas 2 casas decimais.' : 'Fração'">
          <input :id='cpntId + "--checkbox"' type="checkbox" class="app-checkbox" v-model="usarDecimal" :disabled="cpntDisabled" @change="cpntInputBotaoAlterarUsarDecimal">
          <label :for='cpntId + "--checkbox"'></label>
        </div>
      </template>

      <!-- SETA O CAMPO QUE VAI APRESENTAR ALETA -->
      <App-Button v-if="cpntAlerta !== ''" :cpntIcone="'alerta-amarelo'" :cpntExplica="{ mensagem: cpntAlerta }" :cpntClass="'btn btn-default btn-sm cpnt-app-campo-botao-alerta'"></App-Button>

      <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
      <span class="cpnt-barra"></span>
      
      <!-- SETA O TITULO DO CAMPO -->
      <label :for='cpntId' v-if="[ '', null, undefined ].indexOf(cpntNome) === -1 || [ '', null, undefined ].indexOf(cpntExplica) === -1" :title="cpntNome">
        <!-- SETA O NOME DO CAMPO -->
        <span v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html='cpntNome'></span>

        <!-- SETA A EXPLICAÇÃO DO CAMPO -->
        <App-Explica v-if="[ '', null, undefined ].indexOf(cpntExplica) === -1"
          :cpntId='cpntId + "-explica"' 
          :cpntTitle='cpntExplica.mensagem'
          :cpntPositionMy='cpntExplica.posicaoMy'
          :cpntPositionAt='cpntExplica.posicaoAt'
          :cpntClasses='cpntExplica.class'
        ></App-Explica>
      </label>

      <!-- SETA UM AVISO ABAIXO DO CAMPO -->
      <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>
    </template>
  </div>
</template>

<style scoped>
  .cpnt-app-geral > .rf-status {
    text-align: left;
  }
 .cpnt-input-placa > input {
   text-transform: uppercase;
 }
 .cpnt-input-decimal > input {
   padding-right: 28px;
 }
 .cpnt-input-botao-decimal {
    float: right;
    /* position: relative !important; */
    z-index: 1;
    position: relative;
    margin-top: -28px;
    height: 30px;
    height: 30px;
    width: 30px;
    padding: 0px;
    text-align: center;
  }
</style>

<style>
  .permissao > table > tr > td.icone,
  .permissao > table > tr > td.mensagem {
    visibility: visible;
  }
    .permissao > table > tr > td.icone > svg {
      font-size: 25px;
    }
</style>

<script>
  import { TheMask } from 'vue-the-mask'
  // import { CurrencyInput } from 'vue-currency-input'

  export default {
    props: {
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-input-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntStatus: {
        required: true
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntType: {
        required: false,
        type: String,
        default: function () {
          return 'text'
        }
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntValue: {
        type: [ String, Number ],
        required: true
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMask: {
        required: false,
        validator: function (mask) {
          // INICIA O VETOR DE VALORES VALIDOS
          var vetor = [ '', null, undefined, 'chave_acesso', 'telefone', 'cnpj_cpf', 'cep', 'data', 'placa', 'cnpj', 'cpf', 'numero_decimal', 'VALOR_DECIMAL_CAMPO', 'numero_decimal2', 'valor', 'valorMoeda', 'valorDecimalNovo' ]

          // VERIFICA SE A MASCARA TEM UM VALOR VALIDO
          if (vetor.indexOf(mask) === -1) {
            // REMOVE OS VALORES NÃO VALIDOS PARA MENSAGEM
            vetor = vetor.filter(item => [ '', null, undefined ].indexOf(item) === -1)

            // APRESENTA A MENSAGEM DE ERRO
            throw new Error('O valor (' + mask +') informado na chave cpntMask é inválido. Os valores validos são [ ' + vetor.join(', ') + ' ].')
          }
          
          // RETORNA QUE A MASCARA É VALIDA
          return true
        },
        default: function () {
          return null
        }
      },
      cpntMaxLength: {
        type: Number,
        required: false,
        default: function () {
          return 99999999
        }
      },
      cpntMaskPrecision: {
        type: [ Number, Object ],
        required: false,
        default: function () {
          return { min: 2, max: 4 }
        }
      },
      cpntAlerta: {
        type: String,
        required: false,
        default: function () {
          return ''
        }
      },

      // FUNÇOES DO COMPONENT
      cpntOnChange: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnKeyDown: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      TheMask
      // CurrencyInput
    },
    data: function () {
      return {
        iniciando: true,
        statusGeral: 'carregando',
        value: '__INICIAL__',
        autoDecimalMode: false,
        precisao: { min: 2, max: 4 },
        usarDecimal: false
      }
    },
    mounted: function () {
      if (this.cpntMask === 'valorDecimalNovo' && isNaN(this.cpntValue) === false) {
        if (this.cpntValue !== '') {
          // PEGA O VALOR DO CAMPO
          var valor = Number(JSON.parse(JSON.stringify(this.cpntValue))).toString()
  
          // PEGA O VALOR RECEBIDO E SEPARA OS NUMEROS DECIMAIS
          var partes = Number(valor).toString().split('.')
  
          // VERIFICA SE O TAMANHO RECEBIDO É UM TAMANHO VALIDO
          if (partes.length === 2 && partes[1].length >= 3 && this.usarDecimal === false) {
            // SETA QUE SERÁ UTILIZADO CASAS DECIMAIS
            this.usarDecimal = true
            // this.cpntInputBotaoAlterarUsarDecimal()
  
            // SETA O VALOR ATUALIZADO DO CAMPO
            this.value = this.$store.state.FUN_MASK_VALOR(this.cpntMask, valor)
          } else {
            // ADICIONA DUAS CADAS DECIMAIS SE NÃO TIVER NO CAMPO
            if (partes.length === 1) {
              partes.push('00')
            } else if (partes[1].length === 1) {
              partes[1] = partes[1] + '0'
            }
  
            // MONTA O VALOR NOVAMENTE
            valor = partes.join(',')
  
            // SETA O VALOR INICIAL DO CAMPO
            this.cpntInputSetarValueInput(valor)
          }
        } else {
          this.value = ''
        }
      } else if (this.cpntMask === 'valorDecimalNovo') {
        if (this.cpntValue !== '') {
          // PEGA O VALOR UNITARIO RECEBIDO
          var _valor = JSON.parse(JSON.stringify(this.cpntValue)).toString()

          // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
          _valor = _valor.split(',')

          // SETA A MASCARA QUE DEVE USAR
          this.usarDecimal = (_valor[_valor.length -1].length >= 3)

          // SETA O VALOR INICIAL DO CAMPO
          this.cpntInputSetarValueInput(JSON.parse(JSON.stringify(this.cpntValue)))
        } else {
          this.value = ''
        }
      } else {
        // SETA O VALOR INICIAL DO CAMPO
        if (this.cpntMask === 'valorMoeda' && this.cpntValue === '') {
          this.value = ''
        } else {
          this.cpntInputSetarValueInput()
        }
      }

      // CRIA OS OBSERVADORES DO CAMPO
      this.cpntInputCriarObservadores()

      // LIBERA O CARREGAMENTO DA PAGINA
      setTimeout(() => { this.statusGeral = '' }, 100)
    },
    destroyed: function () {
      if ([ '', null, undefined ].indexOf(this.$refs.input) === -1 && [ '', null, undefined ].indexOf(this.$refs.input.$el) === -1) {            
        // REMOVE A OPÇÃO KEY UP
        this.$refs.input.$el.removeEventListener('keyup', this.cpntInputSetarOnKeyUp)

        // REMOVE A OPÇÃO KEY UP
        this.$refs.input.$el.removeEventListener('keydown', this.cpntInputOnKeyDown)

        // SETA A OPÇÃO BLUR
        this.$refs.input.$el.removeEventListener('blur', this.cpntInputOnBlur)
      }
    },
    methods: {
      cpntInputBotaoAlterarUsarDecimal: function () {
        if (this.cpntMask === 'valorDecimalNovo') {
          // // ATUALIZA A MASCARA QUE DEVE ATUALIZAR
          // this.usarDecimal = !this.usarDecimal
  
          // VERIFICA SE DEVE FORMATAR O NUMERO
          if (this.usarDecimal === false) {
            // PEGA O VALOR DO CAMPO
            var valor = this.value
  
            // VERIFICA SE É UM NUMERO
            if (isNaN(valor) === true) {
              // REMOVE O PONTO
              while (valor.indexOf('.') !== -1) {
                valor = valor.replace('.', '')
              }
  
              // CONVERTE A VIRGULA
              valor = valor.replace(',', '.')
            }
  
            // FAZ A SEPARAÇÃO PARA VERIFICAÇÃO
            valor = valor.split('.')
  
            // VERIFICA SE É UM NUMERO DECIMAL OU NÃO
            if (valor.length >= 2 && valor[valor.length -1].length >= 3) {
              // PEGA O VALOR DO CAMPO E JUNTA
              valor = valor.join('.')
  
              // ARREDONDA O VALOR 
              valor = Number(valor).toFixed(2)
  
              // REMOVE O PONTO DO NUMERO
              valor = valor.replace('.', '')
  
              // SETA O VALOR ATUALIZADO DO CAMPO
              this.value = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
            }
          } else {
            // FAZ A MUTAÇÃO DO CAMPO
            this.cpntInputSetarValueInput()
          }
  
          // REALIZA O FOCUS NO CAMPO
          this.cpntRealizarFocus()
        }
      },
      cpntInputCriarObservadores: function (tentativa = 0) {
        if (tentativa <= 5 && [ '', null, undefined, 'numero_decimal', 'VALOR_DECIMAL_CAMPO', 'numero_decimal2', 'valor', 'valorMoeda' ].indexOf(this.cpntMask) === -1) {
          if ([ '', null, undefined ].indexOf(this.$refs.input) !== -1 || [ '', null, undefined ].indexOf(this.$refs.input.$el) !== -1) {            
            setTimeout(() => { this.cpntInputCriarObservadores((tentativa + 1)) }, 100)
          } else {
            // SETA A OPÇÃO KEY UP
            this.$refs.input.$el.addEventListener('keyup', this.cpntInputSetarOnKeyUp)

            // SETA A OPÇÃO KEY DOWN
            this.$refs.input.$el.addEventListener('keydown', this.cpntInputOnKeyDown)

            // SETA A OPÇÃO BLUR
            this.$refs.input.$el.addEventListener('blur', this.cpntInputOnBlur)
          }
        }
      },
      cpntInputSetarOnKeyUp: function (event) {
        switch (event.key) {
          case 'Enter':
            this.cpntInputOnKeyPressEnter()
            break
        }
      },
      cpntInputSetarValueInput: function (valor = this.cpntValue) {
        // CONVERTE O VALOR RECEBIDO
        if ((this.cpntDisabled === true && this.cpntValue === '') === false) {
          if ([ 'valor' ].indexOf(this.cpntMask) !== -1) {
            if (typeof valor === 'string' && isNaN(valor) === true) {
              // REMOVE O PONTO
              while (valor.indexOf('.') !== -1) {
                valor = valor.replace('.', '')
              }
              // REMOVE A VIRGULA
              while (valor.indexOf(',') !== -1) {
                valor = valor.replace(',', '')
              }
              
              // CONVERTE O VALOR
              valor = (valor / 100)
            }
  
            // CONVERTE O VALOR PARA NUMERO
            valor = Number(valor)
  
            // VERIFICA SE TEM UM VALOR VALIDO
            if ([ '', null, undefined, NaN ].indexOf(valor) !== -1) {
              valor = 0.00
            }
  
            // VERIFICA A PRECISÃO QUE DEVE PREENCHER
            switch (this.cpntMask) {
              case 'valor':
                this.precisao = { min: 2, max: 2 }
                this.autoDecimalMode = true
                break
  
              case 'numero_decimal':
              case 'numero_decimal2':
                this.precisao = { min: 2, max: 4 }
                this.autoDecimalMode = false
                break
            }
          } else if ([ 'VALOR_DECIMAL_CAMPO' ].indexOf(this.cpntMask) !== -1) {
            if ([ '', null, undefined ].indexOf(valor) === -1) {
              if (this.iniciando === true) {
                // SETA O FLAG
                this.iniciando = false
    
                // FORMATA O VALOR 
                valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', valor.toString())              
              } else {
                valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_CAMPO', valor.toString())
              }
            }
          } else if ([ 'numero_decimal', 'numero_decimal2' ].indexOf(this.cpntMask) !== -1) {
            // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
            if (typeof valor === 'number') {
              valor = valor.toString()
            }

            var negativo = valor.toString().substring(0, 1) === '-'
            if (negativo === true) {
              valor = valor.substring(1, valor.length)
            }

            if (typeof valor === 'string' && isNaN(valor) === false) {
              valor = valor.replace('.', ',')
            }

            var valorOriginal = valor
            var tamanho = valorOriginal.length

            // eliminando que o usuario digite qualquer letra do alfabeto ou caracteres estranhos
            var digits = '0123456789,'

            for (var v = 0; v < tamanho; v++) {
              if (digits.indexOf(valorOriginal.charAt(v)) === -1) {
                valorOriginal = valorOriginal.substring(0, v)
                break
              }
            }

            valor = valorOriginal

            if (negativo === true) {
              valor = '-' + valor
            }
          } else if ([ 'valorMoeda' ].indexOf(this.cpntMask) !== -1 || (this.cpntMask === 'valorDecimalNovo' && this.usarDecimal === false)) {
            valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
          }
        }

        // SETA O VALOR MONTADO
        this.value = valor
      },
      cpntInputOnChangeValue: function () {
        // PEGA O VALOR RECEBIDO
        var valor = JSON.parse(JSON.stringify(this.value))

        // VERIFICA SE TEM QUE CONVERTER ALGUM VALOR
        if ([ 'placa' ].indexOf(this.cpntMask) !== -1) {
          valor = valor.toLocaleUpperCase()
        } else if ([ 'valorMoeda' ].indexOf(this.cpntMask) !== -1) {
          // CONVERTE O VLAOR EM STRING
          valor = valor.toString()

          // REMOVE OS PONTOS DA STRING
          while (valor.indexOf('.') > -1) {
            valor = valor.replace('.', '')
          }
          // REMOVE A VIRGULA DA STRING
          while (valor.indexOf(',') > -1) {
            valor = valor.replace(',', '')
          }

          // VERIFICA SE DEVE INFORMAR ZERO EM VEZ DE 000
          if ([ '', null, undefined, '00', '000', '0,00' ].indexOf(valor) !== -1) {
            valor = '0'
          }

          // CONVERTE O VALOR SOLICITADO
          valor = parseInt(valor, 10).toString()
        } else if ([ 'numero_decimal' ].indexOf(this.cpntMask) !== -1) {
          // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
          if (typeof valor === 'number') {
            valor = valor.toString()
          } else {  
            // REMOVE OS PONTOS DA STRING
            while (valor.indexOf('.') !== -1) {
              valor = valor.replace('.', '')
            }
            // REMOVE A VIRGULA DA STRING
            while (valor.indexOf(',') !== -1) {
              valor = valor.replace(',', '.')
            }
          }

          // // VERIFICA SE DEVE COMPLEMENTAR O VALOR
          // if (valor === ',' || valor === '.') {
          //   valor = '0' + valor
          // }

          // FORMATA O VALRO QUE SERÁ ENVIADO
          valor = Number(Number(valor).toFixed(4)).toString()

          // VERIFICA SE TEM VIRGULA OU PONTO NO CAMPO
          // if (this.$refs.input !== document.activeElement && valor.indexOf('.') === -1 && valor.indexOf(',') === -1) {
          if (this.$refs.input !== document.activeElement) {
            valor = this.cpntInputFormatarValorFinal(valor)
          }
        } else if ([ 'VALOR_DECIMAL_CAMPO' ].indexOf(this.cpntMask) !== -1) {
          if ([ '', null, undefined ].indexOf(valor) === -1) {
            if (this.iniciando === true) {
              // SETA O FLAG
              this.iniciando = false
  
              // FORMATA O VALOR 
              valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_FRONT', valor.toString())              
            } else {
              valor = this.$store.state.FUN_MASCARA_VALOR('VALOR_DECIMAL_CAMPO', valor.toString())
            }
          }
        } else if ([ 'numero_decimal2' ].indexOf(this.cpntMask) !== -1 && valor !== '') {
          // VERIFICA SE É UM NUMERO, SE FOR CONVERTE PARA STRING
          if (typeof valor === 'number') {
            valor = valor.toString()
          } else {  
            // REMOVE OS PONTOS DA STRING
            while (valor.indexOf('.') !== -1) {
              valor = valor.replace('.', '')
            }
            // REMOVE A VIRGULA DA STRING
            while (valor.indexOf(',') !== -1) {
              valor = valor.replace(',', '.')
            }
          }

          // // VERIFICA SE DEVE COMPLEMENTAR O VALOR
          // if (valor === ',' || valor === '.') {
          //   valor = '0' + valor
          // }

          // FORMATA O VALRO QUE SERÁ ENVIADO
          valor = Number(Number(valor).toFixed(4)).toString()

          // VERIFICA SE TEM VIRGULA OU PONTO NO CAMPO
          // if (this.$refs.input !== document.activeElement && valor.indexOf('.') === -1 && valor.indexOf(',') === -1) {
          if (this.$refs.input !== document.activeElement) {
            valor = this.cpntInputFormatarValorFinal(valor)
          }
        }

        // VERIFICA SE DEVE ATUALIZAR O VALOR
        if ([ 'VALOR_DECIMAL_CAMPO' ].indexOf(this.cpntMask) !== -1) {
          // SETA O VALOR MONTADO
          this.value = valor

          // CHAMA A FUNÇÃO PARA ATUALIZAR OS VALORES
          if (valor !== this.cpntValue && (this.cpntValue === '' && valor === '0') === false) {
            this.cpntOnChange(valor, this.cpntId)
          }
        } else if (valor !== this.cpntValue && (this.cpntValue === '' && valor === '0') === false) {
          this.cpntOnChange(valor, this.cpntId)
        }
      },
      cpntRealizarFocus: function (tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs.input) === -1 && this.cpntMostrar === true && this.cpntInputStatusCampo === '') {
            // PEGA O CAMPO SOLICITADO
            var input = this.$refs.input.$el !== undefined ? this.$refs.input.$el : this.$refs.input
    
            // REALIZA O FOCUS NO CAMPOS
            input.select()

            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_POSICIONAR_SCROLL_FOCUS_CAMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_POSICIONAR_SCROLL_FOCUS_CAMPO

            // EXECUTA A FUNÇÃO IMPORTADA
            FUN_POSICIONAR_SCROLL_FOCUS_CAMPO(input)
          } else {
            setTimeout(() => { this.cpntRealizarFocus((tentativa + 1)) }, 250)
          }
        }
      },
      cpntInputOnKeyPressEnter: function () {
        if (this.cpntOnKeyPressEnter !== null) {
          this.cpntOnKeyPressEnter(this.cpntId)
        }
      },
      cpntInputOnKeyDown: function (event) {
        if (event.isComposing || event.keyCode === 229) {
          return
        } else if (this.cpntOnKeyDown !== null) {
          this.cpntOnKeyDown(this.cpntId, event)
        }
      },
      cpntInputFormatarValorFinal: function (valor) {
        // PEGA O SIMBOLO UTILIZADO NO CAMPO
        var simbolo = valor.indexOf(',') !== -1 ? ',' : '.'

        // CONVERTE O VALOR EM STRING
        valor = valor.toString()

        // VERIFICA SE TEM VIRGULA OU PONTO NO CAMPO
        if (valor.indexOf(simbolo) === -1) {
          valor = valor + simbolo + '00'
        }

        // VERIFICA SE DEVE COMPLEMENTAR O VALOR
        if (valor === simbolo) {
          valor = '0' + simbolo + '00'
        }

        // VERIFICA SE TEM QUE FORMATAR O VALOR
        if ([ '0', ',00' ].indexOf(valor) !== -1) {
          valor = '0' + simbolo + '00'
        }

        // SEPARA O VALOR RECEBIDO
        valor = valor.split(simbolo)

        // VERIFICA SE TEM AO MENOS 2 CASAS DECIMAIS
        if (valor.length === 2 && valor[1].length === 1) {
          valor[1] = valor[1] + '0'
        }

        // MONTA O VALOR NOVAMENTE
        valor = valor.join(simbolo)

        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntInputOnBlur: function () {
        var value = ''
        if ([ 'valorDecimalNovo' ].indexOf(this.cpntMask) !== -1 && this.usarDecimal === true) {
          this.value = this.$store.state.FUN_MASK_VALOR(this.cpntMask, JSON.parse(JSON.stringify(this.value)))
        } else if ([ 'numero_decimal' ].indexOf(this.cpntMask) !== -1) {
          // PEGA O VALOR DO CAMPO
          value = JSON.parse(JSON.stringify(this.value))

          // SETA OS VALORES QUE DEVE COLOCAR NO CAMPO
          if (value.indexOf(',') === -1 && value.indexOf('.') === -1) {
            value = value + ',00'
          }

          // CONVERTE O VALOR EM STRING
          value = this.cpntInputFormatarValorFinal(value)

          // VERIFICA SE TEM QUE ATUALZIAR O VALOR
          if (this.value !== value) {
            this.value = value
          }
        } else if ([ 'numero_decimal2' ].indexOf(this.cpntMask) !== -1 && this.value !== '') {
          // PEGA O VALOR DO CAMPO
          value = JSON.parse(JSON.stringify(this.value))

          // SETA OS VALORES QUE DEVE COLOCAR NO CAMPO
          if (value.indexOf(',') === -1 && value.indexOf('.') === -1) {
            value = value + ',00'
          }

          // CONVERTE O VALOR EM STRING
          value = this.cpntInputFormatarValorFinal(value)

          // VERIFICA SE TEM QUE ATUALZIAR O VALOR
          if (this.value !== value) {
            this.value = value
          }
        }

        if (this.cpntOnBlur !== null) {
          this.cpntOnBlur(this.cpntId)
        }
      },
      cpntInputOnChange: function (value) {
        // VERIFICA O VALOR RECEBIDO
        if (typeof value !== 'string') {  
          // INICIA A VARIAVEL
          var input = this.$refs.input
          
          // VERIFICA SE É UM COMPONENT E PEGA O CAMPO INPUT
          if ([ '', null, undefined ].indexOf(input.$el) === -1) {
            input = input.$el
          }

          // SETA O VALOR RECEBIDO
          value = input.value
        }

        // SETA O VALOR DO CAMPO ATUALIZADO
        this.value = value
      },
      cpntInputOnPaste: function (event) {
        setTimeout(() => { this.value = event.target.value }, 0)
      }
    },
    computed: {
      cpntInputMontarClass: function () {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = []

        // VERIFICA SE TEM ALGUMA MENSAGEM DE VALIDAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
          valor.push('cpnt-app-campo-has-error')
        }

        // VERIFICA SE DEVE INCLUIR FORMATAÇÃO DE PLACA
        if ([ 'placa' ].indexOf(this.cpntMask) !== -1) {
          valor.push('cpnt-input-placa')
        }

        // VERIFICA SE TEM ALERTA PARA O CAMPO
        if ([ '', null, undefined ].indexOf(this.cpntAlerta) === -1) {
          valor.push('cpnt-app-campo-alerta')
        }

        // VERIFICA SE DEVE INCLUIR FORMATAÇÃO DE PLACA
        if ([ 'valorDecimalNovo' ].indexOf(this.cpntMask) !== -1) {
          valor.push('cpnt-input-decimal')
        }
        
        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntInputStatusCampo: function () {
        // SETA O STATUS DO CAMPO
        var valor = this.cpntStatus

        // VERIFICA SE O VALOR É UM VALOR VALIDO
        if (this.cpntStatus === '' && this.cpntValue.toString().indexOf('#403#') !== -1) {
          valor = this.cpntValue
        }

        // VERIFICA SE DEVE SETAR O STATUS DO CAMPO
        if (this.value === '__INICIAL__') {
          valor = 'carregando'
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      cpntInputMontarMascara: function () {
        switch (this.cpntMask) {
          case '':
          case null:
          case undefined:
          case 'valorMoeda':
          case 'numero_decimal':
          case 'VALOR_DECIMAL_CAMPO':
          case 'numero_decimal2':
          case 'valorDecimalNovo':
            return ''

          case 'chave_acesso':
            return [ '#### #### #### #### #### #### #### #### #### #### ####']

          case 'telefone':
            return [ '(##)####-####', '(##)#####-####' ]

          case 'cnpj_cpf':
            return [ '###.###.###-##', '##.###.###/####-##' ]

          case 'cep':
            return [ '##.###-###' ]

          case 'data':
            return [ '##/##/####' ]

          case 'placa':
            return [ 'AAA#X##' ]

          case 'cnpj':
            return [ '##.###.###/####-##' ]

          case 'cpf':
            return [ '###.###.###-##' ]

          default:
            return []
        }
      },
      cpntInputMontarMaxLength: function () {
        switch (this.cpntMask) {
          case 'chave_acesso':
            return 54

          case 'telefone':
            return 15

          case 'cnpj_cpf':
            return 18

          case 'cep':
            return 8

          case 'data':
            return 10

          case 'placa':
            return 7

          case 'cnpj':
            return 18

          case 'cpf':
            return 14

          case 'valorMoeda':
            return 13

          default: 
            return this.cpntMaxLength
        }
      }
    },
    watch: {
      cpntValue: function () {
        this.cpntInputSetarValueInput()
      },
      value: function () {
        this.cpntInputOnChangeValue()
      },
      cpntMask: function () {
        this.cpntInputCriarObservadores()
      }
    }
  }
</script>
